<template>
  <project-detail-layout :tab="3">
    <div class="tab-container">
      <div
        class="tab-item"
        :class="tabOverview ? 'tab-hover' : ''"
        @click="changeToOverView()"
      >
        {{ $t("project_management.project_detail.list_tab.overview") }}
      </div>
      <div
        class="tab-item"
        :class="tabOverview ? '' : 'tab-hover'"
        @click="changeToReview(start_date)"
      >
        {{ $t("project_management.project_detail.list_tab.review") }}
      </div>
    </div>
    <div>
      <div class="overview-container text-center" v-if="tabOverview">
        <div class="overview-container_child">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" :style="haveReviews ? {} : { borderBottomLeftRadius: '25px'}">No</th>
                <th scope="col">
                  {{
                    $t(
                      "project_management.project_detail.table_category.list_week"
                    )
                  }}
                </th>
                <th scope="col">
                  {{
                    $t(
                      "project_management.project_detail.table_category.update_at"
                    )
                  }}
                </th>
                <th
                  scope="col"
                  v-for="(item, index) in listItem"
                  :key="index"
                  :style="index === 7 && !haveReviews ? { borderBottomRightRadius: '25px'} : {}"
                >
                  {{
                    $t(`project_management.project_detail.input_label.${item}`)
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(week, index) in reviews"
                v-show="week.updated_at"
                :key="index"
                @click="changeToReview(index)"
              >
                <td>{{ week.index }}</td>
                <td>{{ week.week_day }}</td>
                <td>{{ week.updated_at }}</td>
                <td v-for="(item, index) in listItem" :key="index">
                  <img
                    class="option__image"
                    :src="changeToImg(week.project_overview_items[item])"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="effort-container" v-else>
        <ValidationObserver v-slot="{ handleSubmit }">
          <Form @submit.prevent="handleSubmit(onSubmit)">
            <div class="input-field">
              <div class="input-wrapper">
                <div class="label">
                  {{ $t("project_management.project_detail.input_label.week") }}
                </div>
                <DatePicker
                  v-model="currentDate"
                  format="DD/MM/YYYY"
                  type="week"
                  value-type="date"
                  :clearable="false"
                  :disabled-date="disableWeekends"
                  :show-week-number="false"
                >
                  <template slot="input">
                    <input
                      class="date-input"
                      :value="`${formatDate(start_date)} ~ ${formatDate(
                        end_date
                      )}`"
                      :style="{ fontWeight: 400 }"
                      disabled
                    />
                  </template>
                </DatePicker>
              </div>
            </div>
            <template v-if="!hasError">
              <div class="input-field row">
                <div
                  class="input-wrapper col-3 mr-0"
                  v-for="(skill, index) in listItem"
                  :key="index"
                >
                  <div class="label">
                    {{
                      $t(
                        `project_management.project_detail.input_label.${skill}`
                      )
                    }}
                    <span class="text-danger">*</span>
                  </div>
                  <multiselect
                    v-model="reviews[start_date].project_overview_items[skill]"
                    :options="optionSelects"
                    :option-height="104"
                    :show-labels="false"
                    :searchable="false"
                    :allowEmpty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <span class="d-none">{{ option }}</span>
<!--                      <img-->
<!--                        v-if="props.option.img"-->
<!--                        class="option__image"-->
<!--                        :src="props.option.img"-->
<!--                      />-->
                      <img
                        class="option__image"
                        :src="changeToImg(reviews[start_date].project_overview_items[skill])"
                      />
                    </template>
                    <template slot="option" slot-scope="{ option }"
                      ><img
                        class="option__image"
                        :src="changeToImg(option)"
                        alt="No Man’s Sky"
                      />
                    </template>
                    <template slot="caret" class="arrow">
                      <div class="select_icon">
                        <img
                          src="@/assets/icons/select_icon.svg"
                          class="caret__icon"
                          alt="select2"
                        />
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="input-field">
                <div class="input-wrapper">
                  <div class="label">
                    {{
                      $t("project_management.project_detail.input_label.note")
                    }}
                  </div>
                  <textarea
                    rows="7"
                    v-model="reviews[start_date].note"
                  ></textarea>
                </div>
              </div>

              <div class="input-field btn_group">
                <button class="confirm-button" type="submit">
                  {{ $t("project_management.kickoff.kickoff_button_submit") }}
                </button>
                <button class="cancel-button" type="button" @click="onBack">
                  {{ $t("project_management.kickoff.kickoff_button_cancel") }}
                </button>
              </div>
            </template>
            <template v-if="hasError">
              <div class="error-notification">
                Ngày không hợp lệ vui lòng chọn ngày trong dự án
              </div>
            </template>
          </Form>
        </ValidationObserver>
      </div>
    </div>
  </project-detail-layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import _ from "lodash";
import ProjectDetailLayout from "./ProjectDetailLayout.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { ValidationObserver, Form } from "vee-validate";

export default {
  components: {
    ProjectDetailLayout,
    DatePicker,
    Multiselect,
    // ValidationProvider,
    ValidationObserver,
    Form,
  },
  data() {
    return {
      value: {
        img: require("@/assets/icons/ellipse_review.svg"),
        value: 1,
      },
      options: [
        {
          img: require("@/assets/icons/ellipse_review.svg"),
          value: 1,
        },
        {
          img: require("@/assets/icons/polygon-review.svg"),
          value: 2,
        },
        {
          img: require("@/assets/icons/vector-x.svg"),
          value: 3,
        },
      ],
      optionSelects: [1, 2, 3],
      currentDate: new Date(),
      start_date: '',
      end_date: '',
      hasError: true,
      tabOverview: true,
      listItem: [
        "scope",
        "communication",
        "skill",
        "tech",
        "schedule",
        "progress",
        "quality",
        "personnel",
      ],
      oldReview: {
        communication: 1,
        personnel: 1,
        progress: 1,
        quality: 1,
        schedule: 1,
        scope: 1,
        skill: 1,
        tech: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      project: "project/project",
      reviews: "project/reviews",
      haveReviews: "project/haveReviews",
    }),

    // start_date() {
    //   const endDate = moment(this.project.end_date, "DD-MM-YYYY");
    //   if (this.project && moment().diff(endDate, 'day') > 0) {
    //     return this.reviews[Object.keys(this.reviews)[0]].start_date;
    //   }
    //   return moment(this.currentDate).startOf("isoWeek").format("YYYY-MM-DD");
    // },
    // end_date() {
    //   return moment(this.start_date).add(4, "day").format("YYYY-MM-DD");
    // },
  },
  async created() {
    await this.getReviews();
    // if (!this.project) {
    //   await this.$store.dispatch('project/showDetail', this.$route.params.id);
    // }
    await this.getStartEndDate();
  },
  watch: {
    currentDate(value) {
      const newStartDate = moment(value).startOf("isoWeek").format("YYYY-MM-DD");
      const oldStartDate = _.cloneDeep(this.start_date);
      if (newStartDate !== oldStartDate) {
        this.reviews[oldStartDate].project_overview_items = this.oldReview;
        this.start_date = newStartDate;
        this.end_date = moment(this.start_date).add(4, "day").format("YYYY-MM-DD");
        const projectStartDate = moment(this.project.start_date, "DD-MM-YYYY");
        const projectEndDate = moment(this.project.end_date, "DD-MM-YYYY");
        if (!this.reviews[this.start_date]) {
          this.reviews[this.start_date] = {
            note: null,
            index: 1,
            project_id: this.$route.params.id,
            project_overview_items: {
              communication: 1,
              personnel: 1,
              progress: 1,
              quality: 1,
              schedule: 1,
              scope: 1,
              skill: 1,
              tech: 1,
            }
          };
          this.oldReview = {
            communication: 1,
            personnel: 1,
            progress: 1,
            quality: 1,
            schedule: 1,
            scope: 1,
            skill: 1,
            tech: 1,
          };
        } else {
          this.oldReview = _.cloneDeep(this.reviews[this.start_date].project_overview_items);
        }
        if (this.project && (moment(this.start_date).diff(projectEndDate, 'day') > 0 || moment(this.end_date).diff(projectStartDate, 'day') < 0)) {
          this.hasError = true;
        } else {
          this.hasError = false;
        }
      }
    },
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    getStartEndDate() {
      const projectStartDate = moment(this.project.start_date, "DD-MM-YYYY");
      const projectEndDate = moment(this.project.end_date, "DD-MM-YYYY");
      if (this.project && (moment(this.start_date).diff(projectEndDate, 'day') > 0 || moment(this.end_date).diff(projectStartDate, 'day') < 0)) {
        if (!this.haveReviews) {
          this.start_date = moment(this.currentDate).startOf("isoWeek").format("YYYY-MM-DD");
          this.end_date = moment(this.currentDate).startOf("isoWeek").add(4, "day").format("YYYY-MM-DD");
        } else {
          this.start_date = this.reviews[Object.keys(this.reviews)[0]].start_date;
          this.end_date = moment(this.start_date).add(4, "day").format("YYYY-MM-DD");
        }
      } else {
        this.start_date = moment(this.currentDate).startOf("isoWeek").format("YYYY-MM-DD");
        this.end_date = moment(this.currentDate).startOf("isoWeek").add(4, "day").format("YYYY-MM-DD");
      }
    },
    disableWeekends (date) {
      const day = new Date(date).getDay();
      return day === 0 || day === 6;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async getReviews() {
      this.setLoading(true);
      const id = this.$route.params.id;
      this.$store
        .dispatch("project/getReviews", {
          id,
        })
        .then(() => {
          this.hasError = false;
        })
        .catch(() => {
          this.hasError = true;
        });
      this.setLoading(false);
    },
    onBack() {
      this.changeToOverView();
    },
    async onSubmit() {
      const id = this.$route.params.id;
      const {
        communication,
        personnel,
        progress,
        quality,
        schedule,
        scope,
        skill,
        tech,
      } = this.reviews[this.start_date]?.project_overview_items;
      const project_overview_items = {
        communication: communication.value ?? communication,
        personnel: personnel.value ?? personnel,
        progress: progress.value ?? progress,
        quality: quality.value ?? quality,
        schedule: schedule.value ?? schedule,
        scope: scope.value ?? scope,
        skill: skill.value ?? skill,
        tech: tech.value ?? tech,
      };
      let reviewData = {
        ...this.reviews[this.start_date],
        start_date: this.start_date,
        end_date: this.end_date,
        project_overview_items: project_overview_items,
      };
      const payload = {
        id,
        formData: reviewData,
      };
      const response = await this.$store.dispatch(
        "project/postReviews",
        payload
      );
      if (response.status == 200) {
        this.$toast(
          "Lưu thành công",
          "Thành công",
          2000,
          "b-toaster-top-center",
          "success"
        );
        const week_day = moment(this.start_date).format("DD/MM/YYYY") + ' - ' + moment(this.end_date).format("DD/MM/YYYY");
        this.reviews[this.start_date].updated_at = moment().format("DD/MM/YYYY");
        this.reviews[this.start_date].week_day = week_day;
        Object.assign({}, this.reviews[this.start_date].project_overview_items, project_overview_items);
        this.getReviews();
        this.changeToOverView(true);
      }
    },

    changeToImg(id) {
      let img;
      this.options.forEach((item) => {
        if (!id) {
          id = 1;
        }
        if (typeof id === 'object' && item.value === id.value) {
          img = item.img;
        } else if (item.value === id) {
          img = item.img;
        }
      });
      return img;
    },
    changeToReview(date) {
      this.oldReview = _.cloneDeep(this.reviews[date].project_overview_items);
      this.tabOverview = false;
      this.currentDate = new Date(date);
      this.start_date = date;
      if (this.reviews[date].end_date) {
        this.end_date = this.reviews[date].end_date;
      }
      const projectStartDate = moment(this.project.start_date, "DD-MM-YYYY");
      const projectEndDate = moment(this.project.end_date, "DD-MM-YYYY");
      if (this.project && (moment(this.start_date).diff(projectEndDate, 'day') > 0 || moment(this.end_date).diff(projectStartDate, 'day') < 0)) {
        this.hasError = true;
      } else {
        this.hasError = false;
      }
    },
    changeToOverView(submit = false) {
      if (!submit) {
        this.reviews[this.start_date].project_overview_items = this.oldReview;
      }
      this.tabOverview = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vue2-datepicker/scss/index.scss";

.mx-table-date {
  .mx-week-number {
    display: none;
  }

  .mx-week-number-header {
    display: none;
  }

  .not-current-month {
    color: #73879c;
    background-color: #ffffff;
  }

  .cell.disabled:not(.not-current-month) {
    color: #73879c;
    background-color: #ffffff;
  }

  td:last-child.not-current-month,
  td:nth-child(2).not-current-month {
    color: #ccc;
    background: white;
  }
}
.tab-container {
  display: flex;
  margin: 0 30px 20px 30px;
  .tab-item {
    width: fit-content;
    font-size: 14px;
    color: #b3b3b3;
    margin-right: 15px;
  }
  .tab-item:hover {
    cursor: pointer;
  }
  .tab-hover {
    font-size: 14px;
    color: #303c54;
    border-bottom: solid #3488eb 4px;
    font-weight: 500;
  }
}
.overview-container {
  margin: 0 auto;
  padding: 0 30px;
  .overview-container_child {
    max-height: 450px;
    overflow: auto;
  }
  table {
    border-collapse: separate;
    border-spacing: 0;
    thead {
      tr {
        th {
          background-color: #3488eb;
          color: #ffffff;
          border-right: solid #ffffff 1px;
          border-bottom-color: #ffffff;
          font-weight: 700;
          position: sticky;
          top: 0;
          position: -webkit-sticky;
        }
        th:first-child {
          border-top-left-radius: 25px;
        }
        th:last-child {
          border-top-right-radius: 25px;
        }
      }
    }
    tbody {
      tr:hover {
        cursor: pointer;
      }
      tr {
        td {
          border: solid #efefef 1px;
          font-weight: 400;
        }
      }
      tr:last-child {
        td:first-child {
          border-bottom-left-radius: 25px;
        }
        td:last-child {
          border-bottom-right-radius: 25px;
        }
      }
    }
  }
}
.effort-container {
  max-width: 642px;
  margin: 0 auto;
  padding: 0 30px;
  form {
    .input-field {
      display: flex;
      @media screen and (max-width: 600px) {
        flex-flow: wrap;
        .input-wrapper {
          flex: 1 1 46%;
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
      .input-wrapper {
        font-family: "Roboto";
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        width: 100%;
        margin-right: 18px;
        &:last-child {
          margin-right: 0;
        }
        .label {
          font-weight: 500;
          font-size: 14px;
          color: #303c54;
          margin-bottom: 8px;
        }
        input {
          background: #ffffff;
          border: 1px solid #cfcfcf;
          border-radius: 5px;
          height: 40px;
          padding: 10px;

          &:focus {
            color: #768192;
            background-color: #fff;
            border-color: #958bef;
            outline: 0;
          }

          @media screen and (max-width: 1024px) {
            width: 100%;
          }
        }
        .date-input {
          width: 100%;
        }
        /deep/ .mx-datepicker-range,
        .mx-datepicker {
          height: 40px;
          width: 48.5%;
          @media screen and (max-width: 600px) {
            width: 100%;
          }
          .mx-input-wrapper {
            height: 40px;
          }
          /deep/ input {
            height: 40px;
          }
        }

        /deep/ .multiselect__tags {
          height: 40px;
          border: 1px solid #cfcfcf;
        }
        textarea {
          border-radius: 5px;
          border: 1px solid #cfcfcf;
          min-height: 30px;
        }
        select {
          .option_1 {
            background-image: url("/../../ellipse_review.svg");
          }
        }
        .select_icon {
          position: absolute;
          width: 40px;
          height: 38px;
          right: 1px;
          top: 1px;
          padding: 4px 8px;
          text-align: center;
          transition: transform 0.2s ease;
        }
        .multiselect--active .select_icon img {
          transform: rotate(180deg);
        }
        &.staff {
          // width: 60%;
          flex: 1 1 60%;
          margin-right: 12px;
        }
        &.effort {
          flex: 1 1 40%;
        }
      }
      &.btn_group {
        display: flex;
        justify-content: center;

        button {
          width: 172px;
          height: 49px;
          border: 1px solid #6e7a8b;
          border-radius: 5px;
          font-family: "Helvetica Neue", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          margin-left: 10px;
        }
        .confirm-button {
          background: #118fa6;
          color: #ebf3f4;
        }

        .cancel-button {
          background: #ffffff;
          color: #1f2d3d;
        }
      }
    }
    .error-notification {
      text-align: left;
      color: red;
      @media screen and (max-width: 600px) {
        text-align: center;
      }
    }
  }
}
/deep/ .mx-week-number {
  display: none;
}
/deep/ .mx-week-number-header {
  display: none;
}
</style>
